import * as modalService from '../modal';
import * as locationService from '../location';

export function authRedirect(url: string, popupUrl: any = null, params = {}): void {
    const $injector = angular.element(document).injector();
    const $rootScope = $injector.get('$rootScope');
    popupUrl = popupUrl || 'partials/auth/SignInPopUp';
    locationService.home();
    setTimeout(() => {
        modalService.launch(popupUrl, {
            tab: url,
            cb: null,
            ...params
        });
        if (!$rootScope.$$phase) {
            $rootScope.$apply();
        }
    });
}
